import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqItems } from '../data/landing';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section aria-labelledby="faq" className="bg-stone-50" data-id="element-61" data-mp="1gjlrlfcegua0">
      <div className="mx-auto max-w-3xl px-5 py-20 lg:py-24" data-id="element-62" data-mp="1gk59wx5ypkok">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-63" data-mp="248o9moay4p51">
          <h2 id="faq" className="font-serif text-3xl leading-[1.06] text-stone-900 sm:text-4xl" data-id="element-64" data-mp="28arwsa6z9i65">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="mt-12 divide-y divide-stone-200 border-y border-stone-200" data-id="element-65" data-mp="1uiv8kh8fjsf1">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-66" data-mp="2n70tb3zhhhev" data-mpi={index}>
                <h3 data-id="element-67" data-mp="2n5z7c4gxjaid">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="group flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-68" data-mp="2rysd8vo4wow1">
                    <span className="text-base font-semibold leading-snug text-stone-900 transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:text-brand sm:text-lg" data-id="element-69" data-mp="10uqeat45rrfp">{item.question}</span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-brand/30 text-brand" data-id="element-70" data-mp="19tllo8ixv7kl">
                      {isOpen ? <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-71" data-mp="1jk6pqbhdt4aw" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-72" data-mp="1jjolosoh9lsf" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="1sl4mq9tekbjz">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-74" data-mp="1slo1xiro4lub">
                      <div className="space-y-3 pb-6 pr-10 text-base leading-relaxed text-stone-600" data-id="element-75" data-mp="287ixton1an52">
                        {item.answer.map(paragraph => <p key={paragraph} data-id="element-76" data-mp="2c9nqol5nrfqn">{paragraph}</p>)}
                      </div>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}